/**
 * FriendAvatar Styles
 * Styles for the FriendAvatar component
 */

import { StyleSheet } from 'react-native';
import { theme } from '../../../theme';

export const friendAvatarStyles = StyleSheet.create({
  fallbackImage: {
    backgroundColor: theme.gray[200],
  },
  placeholderContainer: {
    backgroundColor: theme.primary + '20', // 20% opacity
    alignItems: 'center',
    justifyContent: 'center',
  },
  placeholderText: {
    color: theme.primary,
    fontWeight: '600',
  },
});

/** Size-based styles for avatar container and text (computed from prop). */
export function getFriendAvatarSizeStyles(
  size: number,
  avatarRounded: boolean = true,
): {
  container: {
    width: number;
    height: number;
    borderRadius: number;
    overflow?: 'hidden' | 'visible';
  };
  fallbackImage: { width: number; height: number; borderRadius: number };
  placeholderText: { fontSize: number };
} {
  const radius = avatarRounded ? size / 2 : 0;
  return {
    container: {
      width: size,
      height: size,
      borderRadius: radius,
      ...(avatarRounded ? {} : { overflow: 'visible' as const }),
    },
    fallbackImage: {
      width: size,
      height: size,
      borderRadius: radius,
    },
    placeholderText: {
      fontSize: size * 0.4,
    },
  };
}

